<template>
  <section id="parceiros" class="parceiros">
    <div class="section-title text-center">
      <span class="subtitle">Parceiros</span>
      <h2 class="title">Nossos Parceiros</h2>
      <div class="title-underline"></div>
    </div>
    <div class="infinite-carousel" data-aos="fade-up" data-aos-duration="1000">
      <div class="track" @mouseover="paused = true" @mouseleave="paused = false" :class="{ paused: paused }"> 
        <div class="slide" v-for="(partner, index) in duplicatedPartners" :key="index + '-' + partner.name">
          <div class="partner-logo d-flex justify-content-center align-items-center">
            <img :src="partner.logo" class="img-fluid" :alt="partner.name">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Parcerias',
  data() {
    return {
      paused: false,
      partners: [
        { name: 'Pecunia', logo: require('../../public/assets/images/clients/PecuniaLogo.png') },
        { name: 'RGS', logo: require('../../public/assets/images/clients/DecisionFor.png') },
        { name: 'Scriptorium', logo: require('../../public/assets/images/clients/logoscriptorium.png') },
        { name: 'Golden Bravo', logo: require('../../public/assets/images/clients/goldenbravoo.png') },
        { name: 'Carshelp', logo: require('../../public/assets/images/clients/Carshelp3.0.png') },
        { name: 'creditall Invest', logo: require('../../public/assets/images/clients/creditallInvest.png') },
        { name: 'Invista Global', logo: require('../../public/assets/images/clients/invistaGlobal2.png') },
      ]
    };
  },
  computed: {
    duplicatedPartners() {
      return [...this.partners, ...this.partners, ...this.partners];
    }
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap');

.parceiros {
  padding: 100px 0;
  background: transparent;
  font-family: 'Roboto', sans-serif;
}

.infinite-carousel {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.track {
  background: transparent !important;
}

.section-title {
  margin-bottom: 60px;
  position: relative;
}

.section-title .subtitle {
  color: #bf1b39;
  font-size: 20px;
  font-weight: 600;
  display: block;
  margin-bottom: 15px;
  text-transform: uppercase;
  letter-spacing: 2px;
}

.section-title .title {
  font-size: 42px;
  font-weight: 700;
  color: #212529;
  margin: 0 0 20px;
}

.title-underline {
  width: 80px;
  height: 4px;
  background: #bf1b39;
  margin: 0 auto;
  position: relative;
}

.title-underline:after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: -6px;
  width: 40px;
  height: 4px;
  background: #bf1b39;
  transform: translateX(-50%);
}

.partner-logo {
  width: 100%;
  height: 150px; 
  padding: 30px;
  background: transparent;
  border-radius: 15px;
  box-shadow: none;
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.partner-logo:before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  transition: 0.5s;
}

.partner-logo:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 35px rgba(0,0,0,0.1);
}

.partner-logo:hover:before {
  left: 100%;
}

.partner-logo img {
  max-height: 90px;
  width: auto;
  margin: 0 auto;
  transition: all 0.3s ease;
  filter: grayscale(100%);
}

.partner-logo:hover img {
  filter: grayscale(0%);
  transform: scale(1.05);
}

.infinite-carousel {
  overflow: hidden;
  width: 100%;
  margin-top: 30px;
}

.track {
  display: flex;
  align-items: center;
  animation: marquee 30s linear infinite;
  will-change: transform;
}

.track.paused {
  animation-play-state: paused;
}

.slide {
  flex: 0 0 auto;
  width: 220px;
  margin-right: 24px;
}

.partner-logo {
  width: 100%;
  height: 120px;
  padding: 18px;
  background: transparent;
  border-radius: 15px;
  box-shadow: none;
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

@keyframes marquee {
  0% { transform: translateX(0); }
  100% {
    transform: translateX(calc(-7 * (220px + 24px)));
  }
}

@media (max-width: 768px) {
  .slide { width: 160px; margin-right: 16px; }
  .partner-logo { height: 100px; padding: 12px; }
  .partner-logo img { max-height: 60px; }
  
  @keyframes marquee {
    0% { transform: translateX(0); }
    100% {
      transform: translateX(calc(-7 * (160px + 16px)));
    }
  }
}
</style>
